import React from "react";
import "./sidebar.css";
import TransactionList from "../list/TransactionList";
import logoicon from "../../assets/logo512.png";
import newLogo from "../../assets/newLogo.png";
import logotxt from "../../assets/mylpgtxt.png";
import CashnBankList from "../list/CashnBankList";
import TransReportList from "../list/TransReportList";
import MasterDataList from "../list/MasterDataList";
import PayRollList from "../list/PayRollList";
import { useLocation, useNavigate } from "react-router-dom";
import FinacialReportsList from "../list/FinacialReportsLinst";
import GstReturnList from "../list/GstReturnList";
import TdsTclList from "../list/TdsTcsList";
import { FiHome } from "react-icons/fi";
import store from "../../redux/store";
import { setSidebarWidth } from "../../redux/slice/actionSlice";
import { useSelector } from "react-redux";
import { useWindowSize } from "../../utils/Hook/UseWindowSizeHook";
import DayEndList from "../list/DayEndList";
import FleetManagementList from "../list/FleetManagementList";

const Sidebar = React.memo(() => {
  const windowSize = useWindowSize();
  const { focused } = useSelector((state) => state.actions);
  const location = useLocation();
  const pathName = location?.pathname;
  const navigate = useNavigate();
  // const { user_type, emp_data } = useSelector((state) => state.other);

  const handle_close_drawer = () => {
    if (windowSize?.width < 907) {
      {
        store.dispatch(setSidebarWidth(false));
      }
    }
  };
  const ListComponents = [
    MasterDataList,
    TransactionList,
    CashnBankList,
    FleetManagementList,
    PayRollList,
    GstReturnList,
    TdsTclList,
    TransReportList,
    FinacialReportsList,
    DayEndList,
  ];

  return (
    <div
      className="sidebar-main"
      onMouseEnter={() => {
        if (windowSize?.width > 907) {
          store.dispatch(setSidebarWidth(false));
        }
      }}
      onMouseLeave={() => {
        if (windowSize?.width > 907) {
          store.dispatch(setSidebarWidth(true));
        }
      }}
    >
      <div className="sidebar-logo">
        <img src={newLogo} className="s_logo" />
        <img src={logotxt} className="s_logotxt" />
      </div>
      <div
        style={{
          backgroundColor: pathName == "/Home" ? "white" : "",
        }}
        className="list-main mt10"
        onClick={() => {
          navigate("/Home");
          handle_close_drawer();
        }}
      >
        <div className="list-icon">
          <FiHome color="#6e82a5" size={18} />
        </div>
        <div className="list-title fs15">Home</div>
      </div>
      {ListComponents.map((Component, index) => (
        <Component
          key={index}
          close={handle_close_drawer}
          path={pathName}
          focused={focused}
        />
      ))}
    </div>
  );
});

export default Sidebar;

{
  /* {user_type === "admin" || emp_data?.DAY_END_PERMISSION ? (
        <div
          className="list-main mt10"
          style={{
            backgroundColor: pathName == "/DayEndPage" ? "white" : "",
          }}
          onClick={() => {
            navigate("/DayEndPage");
            handle_close_drawer();
          }}
        >
          <div className="list-icon">
            <MdOutlineWatchLater color="#6e82a5" size={18} />
          </div>
          <div className="list-title fs15">Day End</div>
        </div>
      ) : (
        ""
      )} */
}

{
  /* <MasterDataList
        close={handle_close_drawer}
        path={pathName}
        focused={focused}
      />
      <TransactionList
        close={handle_close_drawer}
        path={pathName}
        focused={focused}
      />
      <CashnBankList
        close={handle_close_drawer}
        path={pathName}
        focused={focused}
      />
      <GstReturnList
        close={handle_close_drawer}
        path={pathName}
        focused={focused}
      />
      <TdsTclList
        close={handle_close_drawer}
        path={pathName}
        focused={focused}
      />
      <TransReportList
        close={handle_close_drawer}
        path={pathName}
        focused={focused}
      />
      <FinacialReportsList
        close={handle_close_drawer}
        path={pathName}
        focused={focused}
      />
      <PayRollList
        close={handle_close_drawer}
        path={pathName}
        focused={focused}
      />
      <DayEndList 
       close={handle_close_drawer}
       path={pathName}
       focused={focused}
       /> */
}
